import { Button, Card, Checkbox, Input } from "@rumbledirect/ui";
import { Form, FormInstance } from "antd";
import { useEffect } from "react";
import { Role } from "@rumble-it/common-lib/types/models/Role.interface";

interface RoleFormCardProps {
  form: FormInstance;
  initialValues?: Role;
  title?: string;
  buttonText?: string;
  loading?: boolean;
  submitting?: boolean;
  onFinish: (values: any) => void;
}

export const RoleFormCard = ({
  form,
  initialValues,
  title = "Rol aanmaken",
  buttonText = "Aanmaken",
  loading = false,
  submitting = false,
}: RoleFormCardProps) => {
  const handleSystemChange = (event: { target?: { checked?: boolean } }) => {
    if (event.target?.checked) {
      form.setFieldValue("externalSsoGroup", null);
    }
  };

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        name: initialValues.name,
        externalSsoGroup: initialValues.externalSsoGroup,
        pending: initialValues.pending,
        dealershipRequired: initialValues.dealershipRequired,
        system: initialValues.system,
      });
    }
  }, [form, initialValues]);

  return (
    <Card loading={loading} title={title}>
      <Form.Item
        help="Gebruik alleen kleine letters en streepjes (-) voor de naam van de rol"
        rules={[{ required: true, message: "Dit veld is verplicht" }]}
        label="Naam"
        name="name"
      >
        <Input />
      </Form.Item>

      <Form.Item
        noStyle
        shouldUpdate={(prevValues, curValues) =>
          prevValues.system !== curValues.system
        }
      >
        {({ getFieldValue }) => {
          const isSystemRole = getFieldValue("system") ?? false;

          return (
            <Form.Item
              help={
                isSystemRole
                  ? "Niet beschikbaar voor systeemrollen"
                  : "Optioneel. Koppel de rol aan een externe SSO-groep (bijv. uuid of string) afhankelijk van de SSO-provider."
              }
              label="Externe SSO-groep"
              name="externalSsoGroup"
            >
              <Input
                placeholder="bijv. uuid of string"
                disabled={isSystemRole}
              />
            </Form.Item>
          );
        }}
      </Form.Item>

      <Form.Item
        name="pending"
        valuePropName="checked"
        style={{ marginTop: 48 }}
      >
        <Checkbox>Pending</Checkbox>
      </Form.Item>

      <Form.Item name="dealershipRequired" valuePropName="checked">
        <Checkbox>Dealership verplicht</Checkbox>
      </Form.Item>

      <Form.Item name="system" valuePropName="checked">
        <Checkbox onChange={handleSystemChange}>Systeem</Checkbox>
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={submitting}>
          {buttonText}
        </Button>
      </Form.Item>
    </Card>
  );
};
